'use strict';
// this is here for backwards compatibility
define('ActivistCodeQuestionView', ['CheckboxListManagerView'], function(CheckboxListManagerView){
  return CheckboxListManagerView.extend({
    __name__: 'ActivistCodeQuestionView',
    type: 'activistCodeQuestion',
    initialize: function() {
      CheckboxListManagerView.prototype.initialize.call(this);
      this.template = this.options.templates.question;
    }
  });
});

